<div class="logo-big">
  <img [src]="logo" />
</div>
<div class="password-container">
  <h3 class="text-center">Set Up Two-Factor Authentication</h3>
  <div class="form-container">
    @if (infoLoading) {
    <spinner-rect></spinner-rect>
    } @if (setup) {
    <form [formGroup]="confirmForm" novalidate (ngSubmit)="onConfirm()">
      <div class="margin-bottom">
        Two-Factor Authentication is now required for your account. Scan the QR code with an
        authenticator app, then enter the 6-digit code it generates.
      </div>
      <img alt="QR Code" class="qr-code" [attr.src]="qrCode" />
      <div class="secret-key margin-bottom">
        Can’t scan the code? Enter this key in your authenticator app (such as Google
        Authenticator). Then enter the 6-digit code generated by the app below.
        <code>{{ secretKey }}</code>
      </div>
      <div class="control margin-bottom">
        <label for="code">Authenticator Code</label>
        <lib-cm-input
          placeholder=""
          formControlName="code"
          id="code"
          [titlecase]="false"
        ></lib-cm-input>
      </div>
      <button type="submit" class="submit-btn margin-bottom" [disabled]="confirmBtnDisabled">
        <div class="spinner-rect-container" [class.show]="confirmLoading">
          <spinner-rect color="white"></spinner-rect>
        </div>
        <div class="title" [class.not-visible]="confirmLoading">Confirm</div>
      </button>
    </form>
    }
    <div class="link text-center">
      <a (click)="onBackToLogin()">Back to login</a>
    </div>
  </div>
</div>
